
<div
  :class="[
    'c-header-menu',
    `-position-${position}`,
    { 'is-visible': shouldShowMenu }
  ]"
  @mouseenter="descheduleHide"
  @mouseleave="scheduleHide"
  @touchstart.passive="startSwipe"
  @touchmove.passive="hideWithSwipe"
  @touchend.passive="endSwipe"
>
  <div
    v-click-outside="handleClickOutside"
    class="c-header-menu__panel"
    :class="{'-transition-disabled': transitionDisabled}"
    :style="[swipeStartTouch ? { transform: `translate3d(${panelHorizontalPosition}, 0, 0)` } : {}]"
  >
    <slot />
  </div>
</div>
